// extracted by mini-css-extract-plugin
export var editButton = "_om-0";